import { make } from 'vuex-pathify';

const state = {
	allByProjects: [],
};

const getters = {};

const mutations = {
	...make.mutations(state),
};

const actions = {

	loadAllOutputsByProject({ commit, rootState, rootGetters }) {
		return new Promise((resolve, reject) => {
			const projectModels = rootGetters['projects/all'];
			const currentProject = rootState.projects.currentProject;
			const allByProjects = [];
			
			// Import dynamically because when just logged in and import axios, authKey is not set yet
			import('@/util/axios').then((axios) => {
				axios.default.get('/outputs/all-outputs', { projectId: currentProject.id }).then((resp) => {
					const projects = resp.data;

					projectModels.each(project => {
						if (!projects[project.id]) {
							return;
						}
						// Assign project name, we don't get it from back-end
						projects[project.id].name = project.name;
						// Count duplicate names in current project, used for importing
						projects[project.id].outputs.forEach(output => {
							const outputsWithSameName = currentProject.outputs.filter(o => o.name.localeCompare(output.name) === 0 && !o.shared);
							output.duplicatesCount = outputsWithSameName.length;
						});
					});

					for (let i in projects) {
						// Exclude current project
						if (currentProject.id === parseInt(i)) {
							continue;
						}
						// Make all project ids negative, in case project id and output id are same,
						// the tree should have unique ids.
						projects[i].id *= -1;
						allByProjects.push(projects[i]);
					}

					commit('SET_ALL_BY_PROJECTS', allByProjects);
					resolve(allByProjects);
				})
				.catch((e) => {
					dump('Error getting all author names', e);
					reject(e);
				});
			});
		});
	},
	
	updateAllOutputsByProject({ state, rootState }) {
		state.allByProjects.forEach(project => {
			project.outputs.forEach(output => {
				const outputsWithSameName = rootState.projects.currentProject.outputs.filter(o => o.name.localeCompare(output.name) === 0 && !o.shared);
				output.duplicatesCount = outputsWithSameName.length;
			});
		});
	}

};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
